import List from './List'

export default List



// WEBPACK FOOTER //
// ./src/components/BetterList/index.js